import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '01',
  title: 'Fundamentos de Biodescodificación',
  desc: 'El origen, la historia y los principios del método. Cómo funciona el vínculo entre emoción y biología. Los principios bio que cambian tu mirada sobre el síntoma.'
}, {
  num: '02',
  title: 'El Mapa del Síntoma',
  desc: 'Los sistemas del cuerpo y su emocionalidad. Cómo interpretar lateralidad, ubicación y tiempo del síntoma. Incluye diccionario bio de síntomas.'
}, {
  num: '03',
  title: 'Transgeneracional y Árbol Bio',
  desc: 'El sistema completo de árbol genealógico bio. Patrones familiares, lealtades y conflictos repetitivos generación tras generación.'
}, {
  num: '04',
  title: 'Protocolos de Sesión',
  desc: 'El protocolo más completo de sesión bio. Paso a paso exacto para conducir, integrar y cerrar sesiones con seguridad.'
}, {
  num: '05',
  title: 'Casos Clínicos Reales',
  desc: 'Más de 20 casos analizados paso a paso para comprender cómo se aplica el método en situaciones reales.'
}, {
  num: '06',
  title: 'Tu Consultorio Holístico Profesional',
  desc: 'Cómo transformar tu práctica en una actividad profesional. Clientes, redes sociales, sesiones online y organización profesional.'
}];
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#faf3e3] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2d3f2a]/5" data-id="element-307">
      <div className="container mx-auto max-w-5xl" data-id="element-308">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-309">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1e3a1e] mb-4" data-id="element-310">
            Formación completa organizada en 6 tomos profesionales
          </h2>
          <p className="text-[#3a4a35] text-base md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-311">
            Una estructura diseñada para avanzar paso a paso desde los
            fundamentos hasta la aplicación práctica y profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-312">
          {TOMOS.map((tomo, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-[#ffffff] border border-[#2d3f2a]/20 rounded-xl p-6 transition-all hover:border-[#5a6b3f]/60 hover:shadow-lg shadow-sm flex gap-5 ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 60}ms`
          }} data-id="element-313">
                <div className="flex-shrink-0" data-id="element-314">
                  <div className="w-14 h-14 rounded-full bg-[#2d3f2a] flex items-center justify-center border-2 border-[#b8860b]/40" data-id="element-315">
                    <span className="text-[#faf3e3] font-serif font-bold text-lg" data-id="element-316">
                      {tomo.num}
                    </span>
                  </div>
                </div>
                <div className="flex-1" data-id="element-317">
                  <h3 className="text-[#1e3a1e] font-serif font-bold text-xl mb-2 leading-tight" data-id="element-318">
                    {tomo.title}
                  </h3>
                  <p className="text-[#1e3a1e] text-sm leading-relaxed" data-id="element-319">
                    {tomo.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}